<template>
    <div class="pricing-table is-comparative" v-if="levels.length && skills.length === selectedSkills.length">
        <div class="pricing-plan is-features">
            <div class="plan-header">&nbsp;</div>

            <div class="plan-price"><span class="plan-price-amount">&nbsp;</span></div>

            <div class="plan-items has-text-weight-bold">
                <div class="plan-item" v-for="skill in skills">
                    {{$t(`skills.${skill.name}.name`)}}
                </div>
            </div>

            <div class="plan-footer"></div>
        </div>

        <div class="pricing-plan level-plan" v-for="level in levels">
            <div class="plan-header">
                {{$t(`levels.${level.name}.name`)}}
            </div>

            <div class="plan-price">
                <span class="plan-price-amount"><level-icon size="is-large" :level="level" /></span>
            </div>

            <div class="plan-items">
                <div class="plan-item" v-for="skill in skills">
                    <span class="is-hidden-tablet has-text-weight-bold">{{$t(`skills.${skill.name}.name`)}}:</span>
                    <price :pay-grade="paygrade(skill, level)"/>
                </div>
            </div>

            <div class="plan-footer">
                <router-link class="button is-primary is-fullwidth is-outlined" :to="{ name: 'students.search' }">
                    Find studerende
                </router-link>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
      // TODO: Consider using variable for media query
    @media screen and (min-width: 769px) {
        .level-plan {
            .plan-footer .button {
                opacity: 0;
            }

            &:hover {
                .plan-footer .button {
                    opacity: 1;
                }
            }
        }
    }
</style>

<script>
    import { mapGetters } from 'vuex';
    import LevelIcon from '@/taskflex/levels/components/LevelIcon';
    import Price from '@/taskflex/skills/components/Price';

    export default {
        data() {
            return {
                selectedSkills: [
                    'accounting',
                    'simple-website',
                    'logo',
                    'market-analysis',
                    'website-maintenance'
                ],
            };
        },

        computed: {
            ...mapGetters({
                levels: 'levels/levels',
                allSkills: 'skills/skills',
            }),

            skills() {
                const { allSkills } = this;

                if (!allSkills.length) {
                    return [];
                }

                return this.selectedSkills.map(name => allSkills.find(skill => skill.name === name));
            },
        },

        mounted() {
            if (!this.allSkills.length) {
                this.$store.dispatch('skills/loadSkillGroups');
            }

            if (!this.levels.length) {
                this.$store.dispatch('levels/loadLevels');
            }
        },

        methods: {
            paygrade({ paygrades = [] }, level) {
                return paygrades.find(paygrade => paygrade.level_id === level.id);
            },
        },

        components: {
            LevelIcon,
            Price,
        },
    };
</script>


// WEBPACK FOOTER //
// src/infrastructure/home/components/SkillPriceTable.vue